import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/course-management`;

export const courseManagementRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:courseId`,
  view: `${baseRoute}/view/:courseId`,
} as const;

export type ICourseManagementRouteParams = IExtractRouteParamMap<
  typeof courseManagementRoutesObj
>;

export const courseManagementPath = createPaths<
  typeof courseManagementRoutesObj,
  ICourseManagementRouteParams
>(courseManagementRoutesObj);
